"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.is-nan");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderColor: theme.borderColor || '#e6e6e6',
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    color: theme.labelColor || 'black'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var NumberType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberType, _React$Component);

  function NumberType(props) {
    var _this;

    _classCallCheck(this, NumberType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberType).call(this, props));

    _this.onChangeNormal = function (text) {
      var onChange = _this.props.onChange;
      var inputValue = text.trim().replace(/,/, '.');

      if (inputValue === '') {
        _this.setState({
          showError: false,
          inputValue: inputValue
        });

        return;
      }

      var parsedValue = Number(inputValue);

      _this.setState({
        inputValue: inputValue
      });

      if (!Number.isNaN(parsedValue)) {
        onChange(parsedValue);

        _this.setState({
          showError: false
        });
      } else {
        _this.setState({
          showError: true
        });
      }
    };

    _this.renderNormal = function () {
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          showError = _this$state.showError;
      return _react["default"].createElement(Input, {
        autoCapitalize: "none",
        underlineColorAndroid: "transparent",
        value: inputValue,
        keyboardType: "numeric",
        onChangeText: _this.onChangeNormal,
        style: showError && {
          borderColor: '#FF4400'
        }
      });
    };

    _this.renderRange = function () {
      var _this$props = _this.props,
          knob = _this$props.knob,
          onChange = _this$props.onChange;
      return _react["default"].createElement(_reactNative.Slider, {
        value: knob.value,
        minimumValue: knob.min,
        maximumValue: knob.max,
        step: knob.step,
        onSlidingComplete: function onSlidingComplete(val) {
          return onChange(parseFloat(val));
        }
      });
    };

    var _knob = _this.props.knob;
    var initialInputValue = Number.isNaN(_knob.value) ? '' : _knob.value.toString();
    _this.state = {
      inputValue: initialInputValue,
      showError: false
    };
    return _this;
  }

  _createClass(NumberType, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var knob = this.props.knob;
      var inputValue = this.state.inputValue;
      return nextProps.knob.value !== knob.value || nextState.inputValue !== inputValue;
    }
  }, {
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      return _react["default"].createElement(_reactNative.View, {
        style: {
          margin: 10
        }
      }, knob.range ? this.renderRange() : this.renderNormal());
    }
  }]);

  return NumberType;
}(_react["default"].Component);

NumberType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
NumberType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    step: _propTypes["default"].number,
    min: _propTypes["default"].number,
    max: _propTypes["default"].number,
    range: _propTypes["default"].bool,
    defaultValue: _propTypes["default"].number
  }),
  onChange: _propTypes["default"].func
};

NumberType.serialize = function (value) {
  return String(value);
};

NumberType.deserialize = function (value) {
  return parseFloat(value);
};

var _default = NumberType;
exports["default"] = _default;